export default __webpack_public_path__ + "static/media/LOGOBUBLE_OK.ccb56e63.png";